module.exports = __webpack_public_path__ + "img/policia_municipal_down.db57fe29.svg";